import { clearData, receiveImmunizationResults, receiveLabResults, setDependents, setDependentsResults, setErrorState, setLogoutErrorState, setSelectedUser, setUser } from '../actions/api'
import { setAcceptedTermsOfUseVersion } from './termsOfUse'
import { setLanguage } from '../actions/language'
import * as digitalIdApi from '../api/digitalIdApi'
import { mapImmunizationResults } from '../api/mappers/immunizationResultMapper'
import { mapFakeLabResults, mapFakeLabResultsWithDependants } from '../api/mappers/labResultMapper'
import mapUser from '../api/mappers/userMapper'
import * as vsApi from '../api/vsApi'
import * as settings from '../globals/settings'
import { ERROR_CONTEXT_LOGIN, ERROR_CONTEXT_LOGOUT, ERROR_CONTEXT_REGISTER, handleErrors } from '../util/error'
import ExtendedError from '../util/extendedError'
import { fakeImmunizationResult, fakeJwt, fakeJwtFR, fakeResponse, fakeResponseDependents } from '../util/fakeData'
import { LANG_EN, LANG_FR } from '../util/language'
import { parseJson } from './api'

var jwtDecode = require('jwt-decode');

export const setGetDependant = (data) => {
    return {
        type: "SET_GET_DEPENDANT",
        data: data,
    }
}

export const setRegistering = (data) => {
    return {
        type: "SET_REGISTERING",
        data: data,
    }
}

export const setOpenIdAuthorizationCode = (data) => {
    return {
        type: "SET_OPENID_AUTHORIZATION_CODE",
        data: data,
    }
}

export const setAuthorizationToken = (data) => {
    return {
        type: "SET_AUTHORIZATION_TOKEN",
        data: data,
    }
}

export const setOpenIdVars = (openIdVars) => {
    return {
        type: "SET_OPENID_VARIABLES",
        verifier: openIdVars.verifier,
        nonce: openIdVars.nonce,
        state: openIdVars.state,
        authorizationCode: openIdVars.authorizationCode,
        authorizeUrl: openIdVars.authorizeUrl,
    }
}

export const setLoginState = (data) => {
    return {
        type: "SET_LOGIN_STATE",
        data: data,
    }
}

export const setFakeLoginState = (data) => {
    return {
        type: "SET_FAKE_LOGIN_STATE",
        data: data,
    }
}

export const setLoggingIn = (data) => {
    return {
        type: "SET_LOGGING_IN",
        data: data,
    }
}

export const setIsLoggingOut = (data) => {
    return {
        type: "SET_IS_LOGGING_OUT",
        data: data,
    }
}

export const setOpenIdAuthorizeUrl = (data) => {
    return {
        type: "SET_OPENID_AUTHORIZE_URL",
        data: data,
    }
}

export const clearAuthData = () => {
    return {
        type: "CLEAR_AUTH_DATA",
    }
}

export const setIsAddingAccess =(data) =>{
    return {
        type: "IS_ADDING_ACCESS",
        data: data,
    }
}

export const doAuthorizeRedirectThunk = () => {
    return function(dispatch, getState) {
        // Build the authorize url
        // FIXME Check if loading
        digitalIdApi.generateAuthorizeUrl()
            .then(openIdVars => {
                // Save openid things for later...
                // Mainly need this to store the codeVerifier
                dispatch(setOpenIdVars(openIdVars));
                // Now redirect user to authorize url
                // NO IDEA how to do this yet!
                // FIXME IMPLEMENT THIS>
                // Probably need to return to a component and use <Redirect /> from react-router?
                // This link might help: https://stackoverflow.com/a/59370777
                //
                // After redirect, digital id will redirect back to us and we need to catch it!
                // Once we catch it, we need to call doVsLogin to complete the flow!
            })
			.catch(err => {
				dispatch(setErrorState(true, err.message, false))
			});
        }
}



// After catching the redirect, call this!
export const catchOpenIdRedirectThunk = (url) => {
    return function(dispatch, getState) {
        // parse the authorizationCode and store
        let { code, state } = digitalIdApi.parseOpenIdUrl(url);
        // Store code in redux.. maybe not necessary
        dispatch(setOpenIdAuthorizationCode(code));
        dispatch(setFakeLoginState(false));
        dispatch(setIsAddingAccess(false));
        let fetching = getState().auth.isLoadingLogin;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // Now send this to vs auth api
        if (fetching === false) {
            let openIdVars = getState().auth.openId;
            let language = getState().language.language;
            let userEmail;
            dispatch(setLoggingIn(true));
            console.log("Authorization Code: " + openIdVars.authorizationCode);
            vsApi.authenticate(openIdVars, language, deviceId)                
                .then(response => {
                    let authorizationToken = vsApi.getAuthorizationToken(response);
                    dispatch(setAuthorizationToken(authorizationToken));
                    return parseJson(response, language);
                })
                .then(obj => {
                    //Check if there has been an error logging in
                    let results = obj.results;
                    if(results.data !=null && results.data.email!= null){
                        userEmail = results.data.email;
                    }
                    let statusCode = obj.statusCode;
                    let error = vsApi.handleLoginErrors(statusCode, results);
                    if (error.error === true) {
                        handleErrors(error, language, ERROR_CONTEXT_LOGIN);
                    }
                    let authorizationToken = getState().auth.authorizationToken;
                    //Get the demographics information of the user from VSF
                    return vsApi.getDemographics(language, deviceId, authorizationToken);
                })
                .then(response => {
                    return parseJson(response, language);
                })
                .then(obj =>{
                    let results = obj.results;
                    //See if we successfully got information
                    if (results.success){
                        let authorizationToken = getState().auth.authorizationToken;
                        let accessLevel = getAccessLevelFromToken(authorizationToken);
                        let modifiedUser = results.data.demographic;
                        modifiedUser.accessLevel = accessLevel;
                        modifiedUser.id = modifiedUser.vsfUserId;
                        modifiedUser.isDependant = false;
                        modifiedUser.email = userEmail;
                        let user = mapUser(modifiedUser);
                        dispatch(setUser(user));
                        dispatch(setAcceptedTermsOfUseVersion(modifiedUser.acceptedTermsVersion));
                        //get the User's associated dependants
                        return vsApi.getDependants(language, deviceId, authorizationToken);
                    }
                })
                .then(response => {
                    return parseJson(response, language);
                })
                .then(obj =>{
                    let results = obj.results;
                    if (results.success){
                        let user = getState().api.user;
                        let dependants = results.data.demographics;
                        if (dependants.length===0){
                            dispatch(setDependents(null));
                        }
                        else{
                            let mappedDependants = [];
                            for(let i = 0; i <dependants.length; i++){
                                let modifiedDependant = dependants[i];
                                modifiedDependant.isDependent = true;
                                modifiedDependant.id= dependants[i].vsfUserId;
                                let mappedDependant = mapUser(modifiedDependant);
                                mappedDependants.push(mappedDependant);
                            }
                            dispatch(setDependents(mappedDependants));
                        }
                        //After getting all details of the user set LoginState to true and logging in to false
                        dispatch(setUser(user));
                        dispatch(setLoginState(true));
                        dispatch(setLoggingIn(false));
                    }
                    //throw error
                })
                .catch(err => {
                    dispatch(setErrorState(true, err.message, true))
                });
        }
    }
}


// Simulates a login without dealing with callbacks.
export const localAuth = (token) => {
    return function(dispatch, getState) {
        console.warn("Warning: Using a manually injected JWT")

        dispatch(setFakeLoginState(false));
        dispatch(setIsAddingAccess(false));
        dispatch(setLoggingIn(true));

        // FIXME What device id?
        let deviceId = "localhost"
        // Now send this to vs auth api
        let language = getState().language.language;
        let userEmail;

        dispatch(setAuthorizationToken(token))

        vsApi.getDemographics(language, deviceId, token)
            .then(response => {
                return parseJson(response, language);
            })
            .then(obj =>{
                let results = obj.results;
                //See if we successfully got information
                if (results.success){
                    let accessLevel = getAccessLevelFromToken(token);
                    let modifiedUser = results.data.demographic;
                    modifiedUser.accessLevel = accessLevel;
                    modifiedUser.id = modifiedUser.vsfUserId;
                    modifiedUser.isDependant = false;
                    modifiedUser.email = userEmail;
                    let user = mapUser(modifiedUser);
                    dispatch(setUser(user));
                    dispatch(setAcceptedTermsOfUseVersion(modifiedUser.acceptedTermsVersion));
                    //get the User's associated dependants
                    return vsApi.getDependants(language, deviceId, token);
                }
            })
            .then(response => {
                return parseJson(response, language);
            })
            .then(obj =>{
                let results = obj.results;
                if (results.success){
                    let user = getState().api.user;
                    let dependants = results.data.demographics;
                    if (dependants.length===0){
                        dispatch(setDependents(null));
                    }
                    else{
                        let mappedDependants = [];
                        for(let i = 0; i <dependants.length; i++){
                            let modifiedDependant = dependants[i];
                            modifiedDependant.isDependent = true;
                            modifiedDependant.id= dependants[i].vsfUserId;
                            let mappedDependant = mapUser(modifiedDependant);
                            mappedDependants.push(mappedDependant);
                        }
                        dispatch(setDependents(mappedDependants));
                    }
                    //After getting all details of the user set LoginState to true and logging in to false
                    dispatch(setUser(user));
                    dispatch(setLoginState(true));
                    dispatch(setLoggingIn(false));
                }
                //throw error
            })
            .catch(err => {
                dispatch(setErrorState(true, err.message, true))
            });
    }
}

// After catching the redirect, call this!
export const fakeAuth = () => {
    return function(dispatch, getState) {
        // parse the authorizationCode and store
                    let results = fakeResponse;
                    dispatch(setLoginState(true));
                    dispatch(setLoggingIn(false));
                    dispatch(setFakeLoginState(true));

                    // Map results
                    if (results.success !== true) {
                        // FIXME HANDLE ERROR.
                        dispatch(setErrorState(true, "Failed to login or fetch lab results", true))
                    } else if(results.data !== null && results.data.patientResults != null) {
                        let { user , sortedResults } = mapFakeLabResults(results.data.patientResults);
                        console.log("LABS: " + sortedResults);
                        dispatch(receiveLabResults(sortedResults));
                        dispatch(setUser(user));

                        let immunizations = fakeImmunizationResult;

                        console.log(immunizations)                        // cant destructure due to name collision with sortedResults
                        const imm  = mapImmunizationResults(immunizations.data.patientImmunization);
                        const sortedImmunizationResults = imm.sortedResults
                        console.log(sortedResults)
                        dispatch(receiveImmunizationResults(sortedImmunizationResults))
                    }
    }

}

// After catching the redirect, call this!
//FakeAuthNew does not allow you to see the current user's results because they do not have a boolean variable set to be true.
export const fakeAuthDependants = () => {
    return function(dispatch, getState) {
        // parse the authorizationCode and store
                    let results = fakeResponseDependents;
                    dispatch(setLoginState(true));
                    dispatch(setLoggingIn(false));
                    dispatch(setFakeLoginState(true));
                    
                    // Map results
                    if (results.success !== true) {
                        // FIXME HANDLE ERROR.
                        dispatch(setErrorState(true, "Failed to login or fetch lab results / immunization record", true))
                    } else if(results.data !== null && results.data.patientResults != null) {
                        let { user , sortedResults, dependents, dependentResults }  = mapFakeLabResultsWithDependants(results.data.patientResults);
                        // console.log("LABS: " + sortedResults);
                        dispatch(receiveLabResults(sortedResults));
                        dispatch(setUser(user));
                        console.log(dependents);
                        dispatch(setDependents(dependents));
                        console.log(dependentResults);
                        dispatch(setDependentsResults(dependentResults));
                        dispatch(setSelectedUser(user));

                        // immunization
                        let immunizations = fakeImmunizationResult;
                        const imm  = mapImmunizationResults(immunizations.data.patientImmunization);
                        const sortedImmunizationResults = imm.sortedResults
                        dispatch(receiveImmunizationResults(sortedImmunizationResults))
                    }
    }

}

// Need to do 2 things here
// 1. Log out of request-gateway (call vs logout)
// 2. Invalidate authorization token for digital id.
export const doLogoutThunk = () => {
    return function(dispatch, getState) {
        dispatch(setIsLoggingOut(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        let authorizationToken = getState().auth.authorizationToken;
        vsApi.logOut(language, deviceId, authorizationToken)
            .then(response => {
                return parseJson(response, language);
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleLogoutErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language, ERROR_CONTEXT_LOGOUT);
                }
                return results;
            })
            .then(result => {
                dispatch(clearAuthData());
                dispatch(clearData());
                return result;
            })
            .then(result => {
                const logoutURL = new URL(settings.LOGOUT_URL)
                const logoutTarget =  language === LANG_EN ? settings.GNB_WEBSITE_EN : settings.GNB_WEBSITE_FR

                logoutURL.searchParams.set("TargetResource", logoutTarget)
                logoutURL.searchParams.set("InErrorResource", logoutTarget)

                window.location.href = logoutURL.href;
            })
            .catch(err => {
                if(err.code === 'ARE' || err.code === 'ADE'){
                    dispatch(setLogoutErrorState(true, err.message, true, true));
                } else {
                    dispatch(setErrorState(true, err.message, true));
                }
            });
    }
}

// Called when we want to do a soft logout
export const clearEverything = () => {
    return function(dispatch, getState) {
        dispatch(clearAuthData());
        dispatch(clearData());
        dispatch(setIsLoggingOut(false));
    }
}

function getAccessLevelFromToken(authorizationToken) {
    try {
        let decodedToken = jwtDecode(authorizationToken);
        let accessLevel = decodedToken.ial;
        if (accessLevel != null) {
            return accessLevel;
        }
        else{
            return null;
        }
    } catch(e) {
        // Do nothing here. The ial variable is not set.
        ;;
    }
}

export const doRegister = (dto) => {
    console.log("Attempting to register dependent...");
    return function(dispatch, getState) {
        dispatch(setRegistering(true));
        let language = getState().language.language;
        let deviceId = getState().api.deviceId;
        let authorizationToken = getState().auth.authorizationToken;
        return vsApi.register(dto, language, deviceId, authorizationToken)
            .then(response => {
                return parseJson(response, language);
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                console.log("Checking for registration error...");
                let error = vsApi.handleRegisterErrors(statusCode, results);
                if (error.error === true) {
                    console.log("Registration error found.");
                    handleErrors(error, language, ERROR_CONTEXT_REGISTER);
                }
                return results;
            })
            .then(result => {
                console.log("No registration error found.");
                dispatch(setRegistering(false));
                return result;
            })
            .catch(err => {
                dispatch(setRegistering(false));
                throw new ExtendedError(err, err.code, err.errorObj);
            });
    }
}

export const doGetDependants = () => {
    return function(dispatch, getState) {
        console.log("Getting dependants...");
        let language = getState().language.language;
        let deviceId = getState().api.deviceId;
        let authorizationToken = getState().auth.authorizationToken;
        dispatch(setGetDependant(true));
        return vsApi.getDependants(language, deviceId, authorizationToken)
            .then((response) =>{
                return parseJson(response, language);
            })
            .then((obj) => {
                let mappedDependants = [];
                let results = obj.results;
                console.log(results)
                if (results.success) {
                    console.log("Dependants grabbed.");
                    console.log("Mapping dependants...");
                    let user = getState().api.user;
                    let dependants = results.data.demographics;
                    if (dependants.length === 0) {
                        user.hasDependants = false;
                        //map dependants
                    }
                    else {
                        user.hasDependants = true;
                        for(let i = 0; i <dependants.length; i++){
                            let modifiedDependant = dependants[i];
                            modifiedDependant.isDependent = true;
                            modifiedDependant.id= dependants[i].vsfUserId;
                            let mappedDependant = mapUser(modifiedDependant);
                            mappedDependants.push(mappedDependant);
                        }
                    }
                    dispatch(setDependents(mappedDependants));
                    console.log("Dependants mapped.");
                }
                return results;
            })
            .then((results) => {
                dispatch(setGetDependant(false));
                return results;
            })
            .catch(err => {
                dispatch(setGetDependant(false));
                dispatch(setErrorState(true, err.message, true))
            }); 
    }
}

//TODO make this function better as it currently does doLogoutThunk with an extra promise to chain for changing the link
export const doAddAccessThunk = () => {
    return function(dispatch, getState) {
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        let authorizationToken = getState().auth.authorizationToken;
        vsApi.logOut(language, deviceId, authorizationToken)
            .then(response => {
                return parseJson(response, language);
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleLogoutErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language, ERROR_CONTEXT_LOGOUT);
                }
                return results;
            })
            .then(result => {
                //digitalIdApi.endSession(authorizationToken)
                //.then(result => {
                    dispatch(clearAuthData());
                    dispatch(clearData());
                    return result;
                //    });
            })
            .then(result =>{
                // TODO Navigate to simeo's logout. This should be configuarable from .env use settings.register link as the target resource.
                let language = getState().language.language;
                let url = language === 'fr' ? settings.MANAGE_ACCOUNT_LINK_FR: settings.MANAGE_ACCOUNT_LINK_EN;
                window.location.href = url;
            })
            .catch(err => {
                if(err.code === 'ARE' || err.code === 'ADE'){
                    dispatch(setLogoutErrorState(true, err.message, true, true));
                } else {
                    dispatch(setErrorState(true, err.message, true));
                }
            });
    }
}
